module.exports = __webpack_public_path__ + "img/type-3.1e4b9f3.png";